import { CheckboxOptionType } from "antd";
import { actionName } from "src/pages/ManagementPage/Obj2Tab/roles/RolesEditor";
import { ActionTypeName } from "src/pages/ManagementPage/Obj2Tab/roles/roleTypes";
import { Permission } from "src/types/Permission";

export const isCopyOptions: CheckboxOptionType[] = [
  {
    value: true,
    label: "Скопировать CRUD  с существующей роли",
  },
  {
    value: false,
    label: "Назначить CRUD ",
  },
];

export const makeActionOptions = (type: ActionTypeName): CheckboxOptionType[] =>
  Object.values(Permission)
    .filter((action) => action.includes(type))
    .map((action) => ({
      value: action,
      label: actionName(action),
    }));

type ActionsField = {
  title: string;
  label: string;
};

export const roleActionFieldsMap: Record<ActionTypeName, ActionsField> = {
  [ActionTypeName.object]: {
    title: "Права на объект",
    label: "Назначить для всех объектов:",
  },
  [ActionTypeName.entity]: {
    title: "Права на экземпляр",
    label: "Назначить для всех экземпляров:",
  },
  [ActionTypeName.attribute]: {
    title: "Права на атрибут",
    label: "Назначить для всех атрибутов:",
  },
};
